/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.FlexCol = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../helpers");

var _classnames6 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FlexCol = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FlexCol, _React$Component);

  function FlexCol() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FlexCol.prototype;

  _proto.componentDidMount = function componentDidMount() {
    require('../../css/flex-grids');
  };

  _proto.render = function render() {
    var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

    var _this$props = this.props,
        col = _this$props.col,
        fixed = _this$props.fixed,
        grow = _this$props.grow,
        alignment = _this$props.alignment,
        contentAlignment = _this$props.contentAlignment,
        breakpoint = _this$props.breakpoint,
        other = _objectWithoutPropertiesLoose(_this$props, ["col", "fixed", "grow", "alignment", "contentAlignment", "breakpoint"]);

    var colClassName = (0, _classnames6["default"])((_classnames = {}, _classnames["col-" + col] = col, _classnames));
    var fixedClassName = (0, _classnames6["default"])({
      'col-fixed': fixed
    });
    var growClassName = (0, _classnames6["default"])((_classnames2 = {}, _classnames2["col-grow-" + grow] = grow, _classnames2));
    var alignmentClassName = (0, _classnames6["default"])((_classnames3 = {}, _classnames3["col-align-" + alignment] = alignment, _classnames3));
    var contentAlignmentClassName = (0, _classnames6["default"])((_classnames4 = {}, _classnames4["col-" + contentAlignment] = contentAlignment, _classnames4));
    var breakpointClassName = (0, _classnames6["default"])((_classnames5 = {}, _classnames5["col-" + breakpoint] = breakpoint, _classnames5));
    var className = (0, _classnames6["default"])('col', colClassName, fixedClassName, growClassName, alignmentClassName, contentAlignmentClassName, breakpointClassName);
    var newProps = (0, _helpers.mergeProps)(other, {
      className: className
    });
    return _react["default"].createElement("div", newProps);
  };

  return FlexCol;
}(_react["default"].Component);

exports.FlexCol = FlexCol;

_defineProperty(FlexCol, "propTypes", {
  col: _propTypes["default"].number,
  fixed: _propTypes["default"].bool,
  grow: _propTypes["default"].number,
  alignment: _propTypes["default"].oneOf(['top', 'middle', 'bottom']),
  contentAlignment: _propTypes["default"].oneOf(['top', 'middle', 'bottom']),
  breakpoint: _propTypes["default"].oneOf(['sm', 'md', 'lg'])
});

;